(function () {
	'use strict';
	document.addEventListener('DOMContentLoaded', function () {
		const thumbs = document.querySelectorAll('.c-pageMovie');

		thumbs.forEach(thumb => {
			thumb.addEventListener('click', function () {
				if (this.querySelector('iframe')) return;

				const videoId = this.getAttribute('data-video-id');
				if (!videoId) return;

				const img = this.querySelector('img');
				if (!img) return;

				const imgWidth = img.offsetWidth;
				const imgHeight = img.offsetHeight;

				this.style.width = imgWidth + 'px';
				this.style.height = imgHeight + 'px';

				const iframe = document.createElement('iframe');
				iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
				iframe.setAttribute('frameborder', '0');
				iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
				iframe.setAttribute('allowfullscreen', 'true');
				iframe.style.width = '100%';
				iframe.style.height = '100%';

				iframe.addEventListener('load', function () {
					img.classList.add('hidden');
				});

				this.appendChild(iframe);
			});
		});
	});
})();
